import get from 'lodash/get';
import { behaviors as GuideItemBehaviors } from '../guideItemTypes';

export default function isSelectable(guideItem) {
  return get(guideItem, 'behaviors.default.actionName') === GuideItemBehaviors.select;
}
